// extracted by mini-css-extract-plugin
export default {"tabContent":"TabContent_tabContent__LHYKz","emptyState":"TabContent_emptyState__a0cvA","emptyHint":"TabContent_emptyHint__nxxeg"};